export class SetObjectState {
  static readonly type = '[Document-Detail] Set Object State';
  constructor(public entities: any) {}
}

export class ResetState {
  static readonly type = '[Document-Detail] Reset State';
  constructor() {}
}

export class UpdateDocument {
  static readonly type = '[Document-Detail] Update Document';
  constructor(public document: any) {}
}

export class DeleteFiling {
  static readonly type = '[Document-Detail] Delete Filing';
  constructor(public docLinkID: any) {}
}

export class SetEditMode {
  static readonly type = '[Document-Detail] Set Edit Mode';
  constructor() {}
}

export class CancelEditMode {
  static readonly type = '[Document-Detail] Cancel Edit Mode';
  constructor() {}
}
